export default "__VITE_ASSET__BoxG04nz__"